import React, { Component } from "react";
import { connect } from "react-redux";
import { creategroupmapping } from "../../../actions/masters/groupmappingActions";
import { Link } from "react-router-dom";
import GroupMappingForm from "./GroupMappingForm";
import history from "../../../history";

class GroupMappingCreate extends Component {
  onSubmit = (formValues) => {
    this.props.creategroupmapping(formValues);
  };

  render() {
    return (
      <div className="BodyInContainer">
        <div className="d-block clearfix">
          <div className="Header-Content float-start">
            <h3 className="pageMainTitle">Add a Group Mapping</h3>
          </div>
          <div className="float-end mt-15">
            <Link
              className="float-end cardBackBtn"
              onClick={() => {
                history.goBack();
              }}
            >
              Back
            </Link>
          </div>
        </div>

        <GroupMappingForm onSubmit={this.onSubmit} />
      </div>
    );
  }
}
export default connect(null, { creategroupmapping })(GroupMappingCreate);
